const es = {
  about: {
    hero: {
      eyebrow: 'Nosotros',
      title: 'Un intermediario independiente basado en el criterio y la discreción',
      description:
        'Existimos para acortar la distancia entre oportunidades solventes y las instituciones e inversores mejor situados para financiarlas.',
      breadcrumb: 'Nosotros',
    },
    storyEyebrow: 'Nuestra Historia',
    storyTitle: 'Nacimos de una observación sencilla',
    story: [
      'El capital rara vez es escaso; lo escaso es la alineación. Una y otra vez hemos visto empresas viables y proyectos bien concebidos que no logran financiación, no por falta de mérito, sino porque llegan al escritorio equivocado, con el formato equivocado y en el momento equivocado.',
      'Yubero Moreno Agentes Financieros S.L. se constituyó para corregir esa ineficiencia. Desde Segovia, y apoyándonos en relaciones construidas a lo largo de más de quince años combinados en banca, deuda privada y asesoramiento en finanzas corporativas, evaluamos cada necesidad con honestidad, la preparamos correctamente y la presentamos únicamente a socios cuyo mandato encaja de verdad.',
      'No somos un banco ni un prestamista directo. Esa independencia es deliberada: significa que nuestra recomendación nunca está limitada por el catálogo de productos o el apetito de riesgo de una sola entidad.',
      'Hoy trabajamos con propietarios de empresas, promotores, patrocinadores de proyectos e inversores en más de cuarenta países, con el respaldo de una red de más de setenta y cinco socios financieros verificados.',
    ],
    missionTitle: 'Nuestra Misión',
    mission:
      'Conectar a prestatarios cualificados y solicitantes de capital con socios financieros de reputación en todo el mundo: con eficacia, confidencialidad y sin exageraciones.',
    visionTitle: 'Nuestra Visión',
    vision:
      'Ser reconocidos internacionalmente como la firma independiente de intermediación más fiable en finanzas corporativas: el nombre que un consejo cita con tranquilidad.',
    valuesEyebrow: 'Valores Fundamentales',
    valuesTitle: 'Seis principios que rigen cada mandato',
    reachEyebrow: 'Alcance Global',
    reachTitle: 'Una red organizada por geografía y mandato',
    reachDescription:
      'Nuestros socios están clasificados por jurisdicción, apetito sectorial, tamaño de operación e instrumento, de modo que las presentaciones son relevantes desde la primera conversación.',
    reachBadge: '75+ socios financieros · 40+ países · 6 regiones',
    regions: [
      { region: 'España y Portugal', detail: 'Banca comercial, deuda inmobiliaria, financiación de circulante' },
      { region: 'Europa y Reino Unido', detail: 'Bancos, deuda privada, financiación de proyectos' },
      { region: 'Oriente Medio', detail: 'Family offices, fondos soberanos, financiación de comercio' },
      { region: 'África', detail: 'Financiación al desarrollo, agricultura, infraestructuras' },
      { region: 'Asia-Pacífico', detail: 'Fondos institucionales, industria, financiación de exportación' },
      { region: 'América', detail: 'Private equity, capital riesgo, financiación con activos' },
    ],
    standardsEyebrow: 'Cómo Trabajamos',
    standardsTitle: 'Estándares, cumplimiento y conducta',
    standards: [
      {
        title: 'Estándares Profesionales',
        description:
          'Nuestro equipo proviene de la banca, el análisis de riesgos y las finanzas corporativas. Cada expediente que presentamos se prepara al nivel que espera un comité de riesgos o de inversión: exacto, completo y coherente.',
      },
      {
        title: 'Compromiso de Cumplimiento',
        description:
          'Todos los clientes y socios se someten a verificación de identidad, indagación del origen de los fondos y cribado de sanciones. Rechazamos cualquier encargo que no pueda verificarse o que quede fuera de nuestro marco de cumplimiento, sea cual sea su tamaño.',
      },
      {
        title: 'Prácticas Éticas',
        description:
          'Nunca garantizamos resultados, nunca contactamos con nadie sin autorización por escrito y nunca ocultamos cómo cobramos. Los honorarios se documentan antes de empezar y decimos no cuando una propuesta todavía no es financiable.',
      },
    ],
    ctaTitle: 'Trabaje con un intermediario que su consejo pueda respaldar',
    ctaDescription:
      'Hable con un miembro senior de nuestro equipo, con total confidencialidad, sobre su necesidad de financiación o inversión.',
    seo: {
      title: 'Nosotros | Yubero Moreno Agentes Financieros S.L.',
      description:
        'Firma independiente e internacional de intermediación de préstamos e inversión con sede en Segovia, España. Conozca nuestra historia, misión, valores, alcance global y compromiso de cumplimiento.',
    },
  },
  services: {
    hero: {
      eyebrow: 'Nuestros Servicios',
      title: 'Deuda, capital y asesoramiento presentados con intención',
      description:
        'Tres áreas de práctica que cubren los instrumentos que empresas y promotores internacionales necesitan con mayor frecuencia.',
      breadcrumb: 'Servicios',
    },
    sectorEyebrow: 'Cobertura Sectorial',
    sectorTitle: 'Sectores en los que presentamos financiación habitualmente',
    processLink: 'Conozca nuestro proceso',
    seo: {
      title: 'Servicios | Intermediación de Préstamos, Inversión y Asesoramiento',
      description:
        'Intermediación de préstamos, inversión y asesoramiento financiero: desde circulante y financiación de comercio hasta private equity, capital riesgo y family offices.',
    },
  },
  how: {
    hero: {
      eyebrow: 'Cómo Funciona',
      title: 'Un proceso de intermediación transparente en siete etapas',
      description:
        'Desde la primera conversación hasta el cierre de la financiación, siempre sabe en qué etapa está y qué sucede a continuación.',
      breadcrumb: 'Cómo Funciona',
    },
    timelineEyebrow: 'El Recorrido',
    timelineTitle: 'Estructurado, secuencial y siempre bajo su control',
    stage: 'Etapa',
    expectationsEyebrow: 'Expectativas',
    expectationsTitle: 'Claridad por ambas partes desde el primer día',
    requirements: [
      {
        title: 'Lo que le pedimos',
        points: [
          'Documentación societaria y estructura de propiedad',
          '2–3 años de cuentas anuales o estados de gestión',
          'Plan de negocio o resumen del proyecto',
          'Proyecciones financieras y destino de los fondos',
          'Detalle de las garantías disponibles',
        ],
      },
      {
        title: 'Lo que nos comprometemos a darle',
        points: [
          'Una evaluación honesta de la financiabilidad',
          'Ningún contacto sin autorización por escrito',
          'Honorarios documentados por adelantado',
          'Listas de socios que usted aprueba primero',
          'Confidencialidad estricta en todo momento',
        ],
      },
      {
        title: 'Plazos indicativos',
        points: [
          'Primera respuesta en 1 día laborable',
          'Evaluación en 48 h desde la documentación',
          'Presentaciones en 2–4 semanas',
          'Term sheets normalmente en 4–8 semanas',
          'Cierre según el proceso de cada socio',
        ],
      },
    ],
    ctaTitle: 'Comience con una consulta confidencial',
    ctaDescription:
      'Cuéntenos qué importe necesita, para qué y en qué plazo. Le diremos con franqueza si podemos ayudarle.',
    seo: {
      title: 'Cómo Funciona | Nuestro Proceso de Intermediación Financiera',
      description:
        'Un proceso transparente en siete etapas: consulta inicial, evaluación, revisión documental, emparejamiento, presentación al financiador, negociación y cierre.',
    },
  },
  faq: {
    hero: {
      eyebrow: 'Preguntas Frecuentes',
      title: 'Preguntas frecuentes',
      description:
        'Respuestas directas a lo que más nos preguntan clientes y socios financieros, incluido lo que no hacemos.',
      breadcrumb: 'Preguntas',
    },
    asideTitle: '¿Tiene otra pregunta?',
    asideLead: 'Hable directamente con nuestro equipo.',
    asideText:
      'La consulta inicial es confidencial y sin coste. Si no somos la firma adecuada para su necesidad, se lo diremos.',
    asideCta: 'Contactar',
    noticeTitle: 'Aviso Importante',
    seo: {
      title: 'Preguntas Frecuentes | Yubero Moreno Agentes Financieros',
      description:
        'Respuestas sobre nuestro papel como compañía de intermediación, requisitos, documentación, países atendidos, plazos, confidencialidad, cumplimiento y honorarios.',
    },
  },
  contact: {
    hero: {
      eyebrow: 'Contacto',
      title: 'Inicie una conversación confidencial',
      description:
        'Complete el formulario de consulta o contacte directamente con nuestra oficina. Cada solicitud la revisa un miembro senior del equipo.',
      breadcrumb: 'Contacto',
    },
    officeTitle: 'Información de la Oficina',
    officeRole: 'Oficina Central',
    hoursTitle: 'Horario de Atención',
    hours: [
      { day: 'Lunes – Jueves', time: '09:00 – 18:00' },
      { day: 'Viernes', time: '09:00 – 17:00' },
      { day: 'Sábado – Domingo', time: 'Con cita previa' },
    ],
    hoursNote:
      'Horario peninsular español (CET/CEST). Las consultas internacionales se atienden por correo electrónico fuera de este horario.',
    mapLabel: 'Marcador de mapa con la ubicación de nuestra oficina en Segovia',
    mapCaption: 'Marcador de Google Maps',
    disclaimerTitle: 'Aviso Legal',
    fiscalTitle: 'Datos Fiscales',
    cifLabel: 'CIF',
    vatLabel: 'Número de IVA',
    form: {
      title: 'Consulta de Financiación e Inversión',
      intro:
        'Los campos marcados con asterisco son obligatorios. Todas las solicitudes se tratan con absoluta confidencialidad.',
      name: 'Nombre completo *',
      namePlaceholder: 'Javier Martín Ruiz',
      company: 'Empresa',
      companyPlaceholder: 'Promociones Martín S.L.',
      country: 'País *',
      countryPlaceholder: 'España',
      email: 'Correo electrónico *',
      emailPlaceholder: 'nombre@empresa.com',
      phone: 'Teléfono',
      phonePlaceholder: '+34 600 000 000',
      funding: 'Financiación requerida *',
      fundingPlaceholder: 'Seleccione un rango',
      purpose: 'Finalidad',
      purposePlaceholder: 'Seleccione una finalidad',
      industry: 'Sector',
      industryPlaceholder: 'Seleccione un sector',
      other: 'Otro',
      message: 'Mensaje *',
      messagePlaceholder:
        'Describa la necesidad, el destino de los fondos, los plazos y las garantías disponibles.',
      upload: 'Adjuntar documentación',
      uploadHint:
        'Adjunte plan de negocio, cuentas o resumen del proyecto (PDF, DOC, XLS — máx. 5 archivos)',
      remove: 'Eliminar',
      submit: 'Enviar Consulta',
      submitting: 'Enviando',
      consent:
        'Al enviar este formulario consiente que revisemos su consulta. No contactaremos con ningún prestamista, inversor o socio financiero sin su autorización previa por escrito.',
      errorBanner: 'Corrija los campos indicados y vuelva a enviar el formulario.',
      successTitle: 'Consulta recibida',
      successText:
        'Gracias. Un miembro senior de nuestro equipo revisará su necesidad y le responderá en un día laborable. Su información se guarda con absoluta confidencialidad y no se compartirá sin su autorización por escrito.',
      successAgain: 'Enviar otra consulta',
      errors: {
        name: 'Introduzca su nombre completo.',
        country: 'Introduzca su país.',
        email: 'Introduzca un correo electrónico válido.',
        funding: 'Seleccione un rango de financiación.',
        message: 'Describa brevemente su necesidad (mínimo 20 caracteres).',
      },
    },
    seo: {
      title: 'Contacto | Consultas de Financiación e Inversión',
      description:
        'Envíe una consulta confidencial de financiación o inversión. Oficina en Navas de San Antonio, Segovia. Respuesta en un día laborable.',
    },
  },
  home: {
    seo: {
      title: 'Yubero Moreno Agentes Financieros S.L. | Intermediación de Préstamos e Inversión',
      description:
        'Compañía independiente de intermediación de préstamos e inversión con sede en Segovia, España. Conectamos empresas, promotores e inversores con bancos, fondos de deuda privada, family offices y socios institucionales en más de 40 países.',
    },
  },
}

const en: typeof es = {
  about: {
    hero: {
      eyebrow: 'About Us',
      title: 'An independent intermediary built on judgement and discretion',
      description:
        'We exist to close the distance between credible opportunities and the institutions and investors best placed to fund them.',
      breadcrumb: 'About',
    },
    storyEyebrow: 'Our Story',
    storyTitle: 'Formed around a simple observation',
    story: [
      'Capital is rarely scarce. Alignment is. Time and again our team watched viable businesses and well-conceived projects fail to raise funding — not because the opportunity lacked merit, but because it reached the wrong desk, in the wrong format, at the wrong moment.',
      'Yubero Moreno Agentes Financieros S.L. was established to correct that inefficiency. Working from Segovia, and drawing on relationships built across more than fifteen combined years in banking, private credit and corporate finance advisory, we assess each requirement honestly, prepare it properly, and introduce it only to partners whose mandate genuinely fits.',
      'We are not a bank and not a direct lender. That independence is deliberate: it means our recommendation is never constrained by a single institution\u2019s product set or risk appetite.',
      'Today we work with company owners, developers, project sponsors and investors across more than forty countries, supported by a network of over seventy-five vetted funding partners.',
    ],
    missionTitle: 'Our Mission',
    mission:
      'To connect qualified borrowers and capital seekers with reputable funding partners worldwide — efficiently, confidentially and without overstatement.',
    visionTitle: 'Our Vision',
    vision:
      'To be recognised internationally as the most trusted independent introduction firm in corporate finance — the name a board is comfortable citing.',
    valuesEyebrow: 'Core Values',
    valuesTitle: 'Six principles that govern every mandate',
    reachEyebrow: 'Global Reach',
    reachTitle: 'A network organised by geography and mandate',
    reachDescription:
      'Our partners are mapped by jurisdiction, sector appetite, ticket size and instrument, so introductions are relevant from the first conversation.',
    reachBadge: '75+ funding partners · 40+ countries · 6 regions',
    regions: [
      { region: 'Spain & Portugal', detail: 'Commercial banking, real estate debt, working capital' },
      { region: 'Europe & United Kingdom', detail: 'Banks, private credit, project finance' },
      { region: 'Middle East', detail: 'Family offices, sovereign-linked funds, trade finance' },
      { region: 'Africa', detail: 'Development finance, agriculture, infrastructure' },
      { region: 'Asia-Pacific', detail: 'Institutional funds, manufacturing, export finance' },
      { region: 'Americas', detail: 'Private equity, venture capital, asset-based lending' },
    ],
    standardsEyebrow: 'How We Operate',
    standardsTitle: 'Standards, compliance and conduct',
    standards: [
      {
        title: 'Professional Standards',
        description:
          'Our team is drawn from banking, credit and corporate finance backgrounds. Every file we present is prepared to the standard a credit or investment committee expects — accurate, complete and internally consistent.',
      },
      {
        title: 'Compliance Commitment',
        description:
          'All clients and partners are subject to identity verification, source-of-funds enquiry and sanctions screening. We decline any engagement that cannot be verified or that falls outside our compliance framework, regardless of its size.',
      },
      {
        title: 'Ethical Business Practices',
        description:
          'We never guarantee outcomes, never make an approach without written authorisation, and never obscure how we are paid. Fees are documented before work begins, and we say no when a proposal is not yet fundable.',
      },
    ],
    ctaTitle: 'Work with an intermediary your board can stand behind',
    ctaDescription:
      'Speak with a senior member of our team in confidence about your funding or investment requirement.',
    seo: {
      title: 'About Us | Yubero Moreno Agentes Financieros S.L.',
      description:
        'An independent international loan and investment introduction firm based in Segovia, Spain. Learn about our story, mission, values, global reach and compliance commitment.',
    },
  },
  services: {
    hero: {
      eyebrow: 'Our Services',
      title: 'Debt, equity and advisory — introduced with intent',
      description:
        'Three practice areas covering the instruments international businesses and sponsors most often require.',
      breadcrumb: 'Services',
    },
    sectorEyebrow: 'Sector Coverage',
    sectorTitle: 'Industries we regularly make funding introductions for',
    processLink: 'Understand our process',
    seo: {
      title: 'Services | Loan, Investment & Advisory Introductions',
      description:
        'Loan introductions, investment introductions and funding advisory — from working capital and trade finance to private equity, venture capital and family office introductions.',
    },
  },
  how: {
    hero: {
      eyebrow: 'How It Works',
      title: 'A transparent, seven-stage introduction process',
      description:
        'From first conversation to completed funding, you always know which stage you are at and what happens next.',
      breadcrumb: 'How It Works',
    },
    timelineEyebrow: 'The Timeline',
    timelineTitle: 'Structured, sequential, and always under your control',
    stage: 'Stage',
    expectationsEyebrow: 'Expectations',
    expectationsTitle: 'Clarity on both sides from day one',
    requirements: [
      {
        title: 'What we ask of you',
        points: [
          'Company registration and ownership details',
          '2–3 years of financials or management accounts',
          'Business plan or project summary',
          'Financial projections and use of funds',
          'Details of available security or collateral',
        ],
      },
      {
        title: 'What we commit to you',
        points: [
          'An honest assessment of fundability',
          'No approach without written authorisation',
          'Fees documented in advance, in writing',
          'Partner shortlists you approve first',
          'Strict confidentiality throughout',
        ],
      },
      {
        title: 'Indicative timing',
        points: [
          'Initial response within 1 business day',
          'Assessment within 48 hours of documents',
          'Introductions within 2–4 weeks',
          'Term sheets typically 4–8 weeks',
          'Completion subject to partner process',
        ],
      },
    ],
    ctaTitle: 'Begin with a confidential consultation',
    ctaDescription:
      'Tell us what you are raising, why, and by when. We will tell you candidly whether we can help.',
    seo: {
      title: 'How It Works | Our Funding Introduction Process',
      description:
        'A transparent seven-stage process: initial consultation, funding assessment, document review, funding match, lender introduction, negotiation and completion.',
    },
  },
  faq: {
    hero: {
      eyebrow: 'FAQ',
      title: 'Frequently asked questions',
      description:
        'Direct answers to the questions clients and funding partners ask most often — including what we do not do.',
      breadcrumb: 'FAQ',
    },
    asideTitle: 'Still have a question?',
    asideLead: 'Speak with our team directly.',
    asideText:
      'Initial consultations are confidential and carry no charge. If we are not the right firm for your requirement, we will tell you.',
    asideCta: 'Contact us',
    noticeTitle: 'Important Notice',
    seo: {
      title: 'Frequently Asked Questions | Yubero Moreno Agentes Financieros',
      description:
        'Answers on our role as an introduction company, eligibility, documentation, countries served, timelines, confidentiality, compliance and how fees are charged.',
    },
  },
  contact: {
    hero: {
      eyebrow: 'Contact',
      title: 'Start a confidential conversation',
      description:
        'Complete the enquiry form below or contact our office directly. Every submission is reviewed by a senior member of our team.',
      breadcrumb: 'Contact',
    },
    officeTitle: 'Office Information',
    officeRole: 'Head Office',
    hoursTitle: 'Business Hours',
    hours: [
      { day: 'Monday – Thursday', time: '09:00 – 18:00' },
      { day: 'Friday', time: '09:00 – 17:00' },
      { day: 'Saturday – Sunday', time: 'By appointment' },
    ],
    hoursNote:
      'Times shown are mainland Spain (CET/CEST). International enquiries are answered by email outside these hours.',
    mapLabel: 'Map placeholder showing the location of our Segovia office',
    mapCaption: 'Google Map placeholder',
    disclaimerTitle: 'Legal Disclaimer',
    fiscalTitle: 'Company Details',
    cifLabel: 'CIF',
    vatLabel: 'VAT Number',
    form: {
      title: 'Funding & Investment Enquiry',
      intro:
        'All fields marked with an asterisk are required. Submissions are treated as strictly confidential.',
      name: 'Full Name *',
      namePlaceholder: 'Javier Martín Ruiz',
      company: 'Company',
      companyPlaceholder: 'Martín Developments S.L.',
      country: 'Country *',
      countryPlaceholder: 'Spain',
      email: 'Email *',
      emailPlaceholder: 'name@company.com',
      phone: 'Telephone',
      phonePlaceholder: '+34 600 000 000',
      funding: 'Funding Required *',
      fundingPlaceholder: 'Select a range',
      purpose: 'Purpose',
      purposePlaceholder: 'Select a purpose',
      industry: 'Industry',
      industryPlaceholder: 'Select an industry',
      other: 'Other',
      message: 'Message *',
      messagePlaceholder:
        'Outline the requirement, intended use of funds, timing and any security available.',
      upload: 'Document Upload',
      uploadHint:
        'Attach business plan, financials or project summary (PDF, DOC, XLS — max 5 files)',
      remove: 'Remove',
      submit: 'Submit Enquiry',
      submitting: 'Submitting',
      consent:
        'By submitting this form you consent to us reviewing your enquiry. We will not approach any lender, investor or funding partner without your prior written authorisation.',
      errorBanner: 'Please correct the highlighted fields and submit again.',
      successTitle: 'Enquiry received',
      successText:
        'Thank you. A senior member of our team will review your requirement and respond within one business day. Your information is held in strict confidence and will not be shared without your written authorisation.',
      successAgain: 'Submit another enquiry',
      errors: {
        name: 'Please enter your full name.',
        country: 'Please enter your country.',
        email: 'Please enter a valid business email.',
        funding: 'Please select a funding range.',
        message: 'Please provide at least a brief outline (20+ characters).',
      },
    },
    seo: {
      title: 'Contact | Funding & Investment Enquiries',
      description:
        'Submit a confidential funding or investment enquiry. Office in Navas de San Antonio, Segovia, Spain. Response within one business day.',
    },
  },
  home: {
    seo: {
      title: 'Yubero Moreno Agentes Financieros S.L. | Loan & Investment Introductions',
      description:
        'Independent loan and investment introduction company based in Segovia, Spain, connecting businesses, developers and investors with banks, private credit funds, family offices and institutional funding partners in 40+ countries.',
    },
  },
}

export const PAGE_STRINGS = { es, en }
